module.exports = __webpack_public_path__ + "img/nexus-tower-live-now.27d60f97.png";